import { render } from "./CardCoinPreferenceList.vue?vue&type=template&id=7c0a4858"
import script from "./CardCoinPreferenceList.vue?vue&type=script&lang=js"
export * from "./CardCoinPreferenceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__